"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.current_user = exports.user_memberships = exports.users = void 0;
exports.users = "/api/users/{user_id}{?brand}";
exports.user_memberships = "/api/users/{user_id}/memberships{?brand}";
exports.current_user = "/api/users/current{?brand}";
